/* hearth-parent.js — behaviour for the five-step parent buying box.
   No Liquid. Everything shop-specific arrives via #hp-config.

   ALL FIVE STEPS ARE DROPDOWNS (Ravi, 20 Aug). The rule:
     If the customer's circumstances decide it, fold it.
     If the customer decides it, show it.
   Size, thickness and grade are dictated by the fireplace opening, so folding
   them costs nothing — opening a dropdown still shows every price. Finish and
   delivery ARE the customer's choice, so their prices are carried by the
   always-on explainer line under each step, not by the control.
   If those explainer lines are ever removed, the upsell goes with them.

   NAMING TRAP: cfg.keySigStd is the LIVE variant title ("Cut to Size & Seal -
   Standard"); cfg.dispSig is what the customer sees ("Signature Package").
   The cart lookup MUST use the key or the paid line vanishes from the basket. */
(function () {
  var variantsEl = document.getElementById('hp-variants');
  if (!variantsEl) return;
  var variants = JSON.parse(variantsEl.textContent);
  var BANDS = JSON.parse(document.getElementById('hp-bands').textContent);
  var cfg = JSON.parse(document.getElementById('hp-config').textContent);

  /* BSD-110 22 Oct 2026 - TRADE VOLUME PRICING. Gold trade accounts get Shopify
     quantity price breaks (1 slab 5% off, 2 = 10%, 3 = 15%, 4+ = 20%) and some
     variants a minimum (900 x 600: 5, from v.quantity_rule). The basket always
     applied them; this page priced v.price x qty, so 4 slabs showed 608 while
     the basket said 512. Breaks come from templates/product.trade-breaks.liquid
     and are only fetched when the trade bar (.bsd-tbar) is on the page, so
     retail pages make no extra request and price exactly as before. */
  var BRK = {};
  function minQty(v) { var m = v && v.quantity_rule ? v.quantity_rule.min : 1; return m > 1 ? m : 1; }
  function unitPrice(v, q) {
    var p = v.price, r = BRK[v.id];
    if (r && r.b) r.b.forEach(function (b) { if (q >= b[0] && b[1] < p) p = b[1]; });
    return p;
  }
  function ladderEl() {
    var el = document.getElementById('hp-ladder');
    if (el) return el;
    var form = document.getElementById('hp-form');
    if (!form) return null;
    var st = document.createElement('style');
    st.textContent = '.hp__ladder{border:2px solid #111;padding:10px 12px;margin:8px 0 12px;font-size:14px;line-height:1.45;background:#fff;color:#111}'
      + '.hp__ladrow{display:flex;flex-wrap:wrap;gap:4px 14px;margin:4px 0}'
      + '.hp__ladrow span.on{font-weight:700;text-decoration:underline}'
      + '.hp__ladnudge{margin-top:4px;font-weight:700}'
      + '.hp__ladmix{margin-top:8px;padding-top:8px;border-top:1px solid #ddd}';
    document.head.appendChild(st);
    el = document.createElement('div');
    el.id = 'hp-ladder';
    el.className = 'hp__ladder';
    el.hidden = true;
    var btn = document.getElementById('hp-atc');
    if (btn && btn.parentNode === form) form.insertBefore(el, btn);
    else form.appendChild(el);
    return el;
  }
  function renderLadder(v, q) {
    var r = (v && BRK[v.id]) || {}, mq = minQty(v);
    var has = !!(r.b && r.b.length);
    var el = (has || mq > 1) ? ladderEl() : document.getElementById('hp-ladder');
    if (!el) return;
    if (!v || (!has && mq <= 1)) { el.hidden = true; el.innerHTML = ''; return; }
    var h = '';
    if (has) {
      var tiers = [[1, v.price]].concat(r.b), cur = unitPrice(v, q);
      h += '<b>Trade price per slab: the more you take, the less you pay</b><div class="hp__ladrow">';
      tiers.forEach(function (t, i) {
        var last = i === tiers.length - 1;
        var lbl = (last ? t[0] + '+' : String(t[0])) + (t[0] === 1 && !last ? ' slab' : ' slabs');
        var on = q >= t[0] && (last || q < tiers[i + 1][0]);
        h += '<span' + (on ? ' class="on"' : '') + '>' + lbl + ' ' + money(t[1]) + '</span>';
      });
      h += '</div>';
      var next = null;
      for (var i = 0; i < r.b.length; i++) { if (r.b[i][0] > q) { next = r.b[i]; break; } }
      if (next) {
        h += '<div class="hp__ladnudge">Add ' + (next[0] - q) + ' more and pay ' + money(next[1]) + ' each. Same pallet, same delivery charge.</div>';
      } else {
        h += '<div class="hp__ladnudge">&#10003; Best trade price: ' + money(cur) + ' each.</div>';
      }
      /* BSD-111: Shopify counts each size separately, so say plainly that a mix still gets 20%. */
      h += '<div class="hp__ladmix"><b>Mixing sizes?</b> Take 4 or more slabs on one order, in any sizes or finishes, and the whole order is 20% off. Add them to your basket and check out as normal. We apply it to your pro forma before you pay.</div>';
    } else {
      h += '<b>Trade minimum ' + mq + ' slabs at ' + money(v.price) + ' each.</b>'
        + '<div>Need just one to collect from Milton Keynes? Call 01908 46 46 56.</div>';
    }
    el.innerHTML = h;
    el.hidden = false;
  }
  function loadBreaks() {
    if (!document.querySelector('.bsd-tbar') || !window.fetch) return;
    fetch(window.location.pathname + '?view=trade-breaks', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (d) { BRK = d || {}; render(); })
      .catch(function () { /* no breaks: page prices at the single-slab rate, basket still correct */ });
  }

  /* ---------------------------------------------------------------------------
     THE SAW ALLOWANCE — added 23 September 2026. Both numbers are Ravi's.

       CUT_KERF = 10   millimetres lost to each saw pass
       MIN_CUT  = 50   we do not cut anything narrower than this

     WHAT WAS WRONG. packPieces() below is a correct guillotine packer with
     rotation, but it subtracted NOTHING for the blade when it split the
     remaining strip, so the fit test was `sum of pieces <= slab dimension`,
     exactly. Verified live 23 Sep on the riven 1200 x 900: two pieces of
     1200 x 450 — 900mm on a 900mm slab — were accepted, priced at £220 and
     addable to basket. 451 + 451 (902mm) was refused, which pinned the rule.
     Two 450mm pieces cannot come out of a 900mm slab.

     NOT A REGRESSION. The 12 Sep theme (198940688761) behaves identically, so
     the gap existed from the day the configurator shipped. The allowance DID
     exist in the Slab Yield Calculator prototype (artifact
     c2399fe6-db1a-44c4-80db-0560a236c996), whose nest() subtracts kerf on both
     splits exactly as this now does. The model was right and the build never
     carried it across — which is why testing against the calculator looked fine.

     THE RULE. A cut is only needed where the piece is SMALLER than the stock it
     comes out of, and every cut costs CUT_KERF. A piece that already matches the
     available dimension needs no cut there. Ravi, 23 Sep: the slab arrives square,
     so the WHOLE slab is usable and there is no outer trim to allow for. That is
     what roomFor() encodes.

     BOUNDARY TEST — re-run after ANY change here. Riven 1200 x 900, Signature:
       2 x (1200 x 445) = 445 + 10 + 445 = 900   -> must be ACCEPTED
       2 x (1200 x 450)                          -> must be REFUSED
       1 x (1200 x 890) = 890 + 10 = 900         -> must be ACCEPTED
       1 x (1200 x 895) needs 905                -> must be REFUSED
       1 x (1200 x 900) matches the slab exactly -> must be ACCEPTED
       1 x (1200 x 40)                           -> must be REFUSED, under MIN_CUT
  --------------------------------------------------------------------------- */
  var CUT_KERF = 10;
  var MIN_CUT = 50;

  function $(id) { return document.getElementById(id); }
  function money(p) { return '£' + (p / 100).toFixed(2); }

  var finSel = $('hp-fin'), spdSel = $('hp-speed'), delSel = $('hp-del'), pieceSel = $('hp-pieces');
  var state = { fin: 'none', speed: 'standard', del: 'collect', pieces: 1 };

  function optSelect(oi) { return document.querySelector('.hp__optselect[data-oi="' + oi + '"]'); }
  function valueAt(oi) { var s = optSelect(oi); return s ? (s.value || null) : null; }
  function setValueAt(oi, v) { var s = optSelect(oi); if (s && v !== null) s.value = v; }
  function chosen() { var o = []; for (var i = 0; i < cfg.optCount; i++) o.push(valueAt(i)); return o; }

  function variantFor(vals) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < vals.length; j++) {
        if (vals[j] === null || String(v.options[j]) !== String(vals[j])) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }
  function currentVariant() { return variantFor(chosen()); }
  function combinationExists(oi, value) {
    var vals = chosen();
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < vals.length; j++) {
        if (j === oi) { if (String(v.options[j]) !== String(value)) { ok = false; break; } continue; }
        if (vals[j] === null) continue;
        if (String(v.options[j]) !== String(vals[j])) { ok = false; break; }
      }
      if (ok) return true;
    }
    return false;
  }
  /* Sold out, asked as a CASCADE rather than three independent questions about
     the same combination. Slots BEFORE oi constrain the search; slots AFTER it
     are wildcards. Asking all three slots about the exact current combination
     is what made one missing variant read as three separate outages — with
     1500 x 900 / 30mm / Premium gone, the size and the thickness both reported
     "sold out" while the yard held 65 slabs of that size. A dropdown should say
     "changing THIS will not help", not "everything is gone". */
  function anyAvailableWith(oi, value, vals) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < oi; j++) {
        if (vals[j] === null) continue;
        if (String(v.options[j]) !== String(vals[j])) { ok = false; break; }
      }
      if (!ok) continue;
      if (String(v.options[oi]) !== String(value)) continue;
      if (v.available !== false) return true;
    }
    return false;
  }
  function cheapestWith(oi, value) {
    var lo = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].options[oi]) !== String(value)) continue;
      if (lo === null || variants[i].price < lo) lo = variants[i].price;
    }
    return lo === null ? 0 : lo;
  }

  function addWorkingDays(n) {
    var d = new Date(); d.setHours(0, 0, 0, 0);
    var added = 0, guard = 0;
    while (added < n && guard < 400) {
      guard++; d.setDate(d.getDate() + 1);
      var dow = d.getDay();
      if (dow === 0 || dow === 6) continue;
      var iso = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
      if (cfg.bankHolidays.indexOf(iso) >= 0) continue;
      added++;
    }
    return d;
  }
  var DAYS = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  var MON = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  function longDate(d) { return DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MON[d.getMonth()]; }
  function shortDate(d) { return DAYS[d.getDay()].slice(0,3) + ' ' + d.getDate() + ' ' + MON[d.getMonth()].slice(0,3); }

  function serviceCost() {
    if (state.fin === 'seal') return cfg.priceSeal;
    if (state.fin === 'sig') return state.speed === 'priority' ? cfg.priceSigPri : cfg.priceSigStd;
    return 0;
  }
  function serviceKey() {
    if (state.fin === 'seal') return cfg.keySeal;
    if (state.fin === 'sig') return state.speed === 'priority' ? cfg.keySigPri : cfg.keySigStd;
    return null;
  }
  function serviceDisplay() {
    if (state.fin === 'seal') return cfg.dispSeal;
    if (state.fin === 'sig') return cfg.dispSig + ' — ' + (state.speed === 'priority' ? cfg.copy.priorityWord : cfg.copy.standardWord);
    return null;
  }
  /* Freight for a given service level. Two bands x two speeds, matching the
     four live rates on the BSD Standard Slab and BSD Oversized Slab delivery
     profiles. `mode` is the value of the delivery select, so 'collect' is
     free and anything else is a pallet. */
  function freight(mode) {
    var v = currentVariant();
    if (!v || !BANDS[v.id]) return null;
    var over = BANDS[v.id].band === 'oversized';
    if (mode === 'express') return over ? cfg.rateOversizedExpress : cfg.rateStandardExpress;
    return over ? cfg.rateOversized : cfg.rateStandard;
  }
  function isDelivery(mode) { return mode === 'deliver' || mode === 'express'; }

  /* Stock held at MILTON KEYNES for a variant, or null when the bands blob
     carries no number for it. Single slabs are stocked at MK; crates are at
     Colchester. */
  function stockAt(v) {
    return (v && BANDS[v.id] && typeof BANDS[v.id].qty === 'number') ? BANDS[v.id].qty : null;
  }

  /* THE QUANTITY, CLAMPED TO WHAT WE ACTUALLY HOLD.
     Ravi, 12 Sep 2026: "whatever stock is held at each location is what we are
     offering."

     This page used to answer "more than Milton Keynes has" with a promise — the
     badge flipped to Colchester and the arrival dates grew transfer_days. That
     promise is withdrawn. Transfers still happen, but moving a crate is a
     replenishment decision the yard makes when it suits, not an order-level
     commitment triggered by a click.

     It also stops the page contradicting the cart. Every variant is now tracked
     with inventoryPolicy DENY, so Shopify ALREADY refuses an above-stock
     /cart/add.js. Quoting a delivery window for a quantity checkout will reject
     is the worst of both worlds.

     The clamped value is written back into the input, so the number on screen is
     the number that gets bought. Never clamps to 0 — a variant at zero is the
     sold-out gate's business, not this one's — and never clamps when stock is
     unknown. qtyCapped carries the fact through to the message below. */
  var qtyCapped = false;
  function qty() {
    var el = $('hp-qty');
    var mq = minQty(currentVariant());
    if (el) el.min = String(mq);
    var want = Math.max(mq, parseInt(el ? el.value : '', 10) || 1);
    if (el && (parseInt(el.value, 10) || 0) < mq) el.value = String(want);
    var have = stockAt(currentVariant());
    qtyCapped = false;
    if (have !== null && have > 0 && want > have) {
      want = have;
      qtyCapped = true;
      if (el && String(el.value) !== String(want)) el.value = String(want);
    }
    return want;
  }

  /* ---------------------------------------------------------------------------
     SOLD OUT — added 11 Sep 2026, and the distinction it draws is the point.

     LOW and SOLD OUT are different questions and this file used to ask only the
     first. Milton Keynes holds single slabs, and the badge now reports MK stock
     and nothing else. It no longer flips to "In stock at our Colchester depot"
     once the order runs past MK: that promise was withdrawn on 12 Sep 2026, and
     a quantity above MK stock is clamped by qty() and handed a phone number
     rather than promised. Do not reinstate the transfer wording.

     What was missing is the other case. Set a variant to "stop selling when out
     of stock" and drop it to zero and Shopify will reject /cart/add.js outright.
     The page had no idea: it priced the slab, enabled the button, took the click,
     and surfaced Shopify's 422 as the generic "something went wrong" alert. The
     shopper was told the site was broken when the truth was the slab was gone.
     Found live on 1500 × 900 / 30mm / Premium (SS-EB-1509030-P).

     `variant.available` in `product.variants | json` is Shopify's OWN verdict and
     is exactly the line Ravi asked for, for free:
       policy CONTINUE  -> always true, at any quantity, so the transfer promise
                           for the other twelve variants cannot be affected by
                           anything in this block.
       policy DENY      -> false once stock hits zero.
     An older comment in this file called `available` useless because every
     variant was CONTINUE at the time. That is why nothing read it. It is no
     longer true, and a comment is not a guarantee — hence reading it here.

     THAT GAP IS CLOSED, 12 Sep 2026. A DENY variant with 2 left used to accept
     an order for 3 here and be refused at the cart. Closing it did not need the
     inventory policy after all: qty() clamps the quantity to the REAL stock in
     BANDS before anything is priced or added, and #hp-qtycap says why. This is
     not an outstanding issue — do not re-open it. ------------------------- */
  function soldOutFor(v) { return !!v && v.available === false; }

  /* Copy reads through cfg.copy with a literal fallback, so this works on the
     current section as-is AND picks up theme-editor settings automatically if
     these four are ever added to sections/hearth-parent.liquid. */
  function say(key, fallback) {
    return (cfg.copy && cfg.copy[key]) ? cfg.copy[key] : fallback;
  }
  function soldOutBtnLabel() { return say('atcSoldOut', 'Sold out'); }
  function soldOutBadge() { return say('stockOut', 'Out of stock — more on the next container'); }
  function soldOutNote() { return say('soldOutNote', 'This one is gone. Every other size and grade on this page is in stock and ships this week.'); }
  function soldOutSuffix() { return say('selectSoldOut', 'sold out'); }

  /* The explanatory line lives directly above the button, because a greyed
     control with no sentence beside it is the thing shoppers email about.
     Built here rather than in the section so this fix stays to one file; it
     borrows the cut-validator's classes rather than adding a CSS rule.

     INSIDE the form, immediately before the button — NOT as a sibling of the
     form in .hp__info. That container is a flex row whose CSS hands every child
     an explicit `order`, so a node the stylesheet has never heard of inherits a
     late one and sinks to the bottom of the box: first attempt rendered this
     sentence below the trade-login link, four elements past the button it was
     explaining. Inside the form it is carried by the form's own order and stays
     welded to the button however .hp__info is later rearranged. */
  function soldOutLine() {
    var el = $('hp-soldout');
    if (el) return el;
    var form = $('hp-form');
    if (!form) return null;
    el = document.createElement('p');
    el.id = 'hp-soldout';
    el.className = 'hp__valid hp__valid--bad';
    el.hidden = true;
    var btn = $('hp-atc');
    if (btn && btn.parentNode === form) form.insertBefore(el, btn);
    else form.appendChild(el);
    return el;
  }

  function qtyCapNote() { return say('qtyCapNote', 'More than we hold at Milton Keynes — call 01908 46 46 56 and we will sort it.'); }

  /* The quantity-cap line: what to do when the clamp in qty() has just taken
     slabs off the order. Built exactly like soldOutLine() above and for the same
     reasons — created ONCE, lazily, `hidden` toggled, text cleared when it has
     nothing to say, borrowing the cut validator's classes so no CSS ships.

     PLACEMENT, and read the note on soldOutLine() before moving it. Under 749px
     hearth-parent.css gives every child of .hp__info an explicit order and
     catches the rest with `.hp__info > * { order: 15 }`, so a node appended to
     .hp__info sinks past the trade-login link to the bottom of the column, far
     from the control it explains. That has already shipped on this store once.
     This lives INSIDE #hp-form and is carried by the form's own order (8).

     .hp__qty (order 5) sits closer to the quantity input and was the first
     choice, but it is `display: flex` with no wrap: a <p> appended there renders
     as a squeezed third column beside the 84px input rather than a line under
     it. Fixing that needs a CSS rule, and no CSS ships with this change. */
  function qtyCapLine() {
    var el = $('hp-qtycap');
    if (el) return el;
    var form = $('hp-form');
    if (!form) return null;
    el = document.createElement('p');
    el.id = 'hp-qtycap';
    el.className = 'hp__valid hp__valid--bad';
    el.hidden = true;
    var btn = $('hp-atc');
    if (btn && btn.parentNode === form) form.insertBefore(el, btn);
    else form.appendChild(el);
    return el;
  }

  /* Guillotine packing: a bridge saw cuts straight across and cannot nibble an
     L-shape, so only guillotine layouts are honest. A general bin-packer would
     approve cuts the yard cannot make. Returns placements so we can draw it.

     EVERY SPLIT COSTS CUT_KERF — see the block at the top of this file. Without
     it this approved two 450mm pieces from a 900mm slab.

     -------------------------------------------------------------------------
     THE LAYOUT PREFERENCE — added 23 September 2026. Ravi, on publish day:
     "The slab would not be cut like this."

     WHAT WAS WRONG. This function returned the FIRST valid arrangement it found
     and stopped. There is usually more than one, and the first one out of the
     recursion is simply whichever the loop order reaches — the side-by-side
     branch, because it is written first. Live on the riven 1500 x 900 with
     1200 x 600 plus 800 x 250, that stood the 800 x 250 on its end in a 290mm
     side strip beside a 600mm-tall neighbour. The fit test was right and the
     yield was right (32% offcut is correct arithmetic). The picture was not a
     cut any saw would run, and a tradesman reading it concludes we do not cut
     stone — the opposite of what the section is for.

     WHAT A CUTTER ACTUALLY DOES. Cross the slab once to open a band the height
     of the pieces, then cross-cut inside that band. Side by side is normal and
     good. What is wrong is side by side at DIFFERENT heights: the band never
     closes, so the offcut comes off as an L instead of a rectangle.

     THE SCORE. Every valid arrangement is now enumerated and the cheapest wins.
     Lower is better, and ties keep the first one found — so any layout that was
     already sensible comes out unchanged.

       ragged x 100   pieces sharing a band but not its height. This is the
                      defect above and it is weighted hardest, because it is
                      what decides whether the offcut is a rectangle or an L.
       rotated x 10   a piece's long side run across the slab instead of down
                      its length. Still a straight cut, so it costs less than a
                      ragged band, but it is not how the piece would be laid on
                      the bed.

     THIS DOES NOT CHANGE WHAT WE ACCEPT. roomFor() is untouched, both split
     branches are untouched, and the search still reaches exactly the same set
     of arrangements — it just no longer stops at the first one. If any layout
     fits, a layout is still returned. Re-run the six boundary cases at the top
     of this file after any change here; every one must land the same way.

     VERIFIED on staging 199534248313, 23 Sep, riven 1500 x 900:
       1200 x 600 + 800 x 250  -> piece 2 at (0, 610), un-rotated, full-width
                                  band. Yield unchanged at 32%.
       700 x 400 x 2           -> still side by side at y 0. Equal heights close
                                  the band, so the old layout was already right
                                  and the tie-break keeps it.
       900 x 400, 900 x 400, 900 x 80 -> three stacked bands, 400+10+400+10+80
                                  = 900 exactly.
  ------------------------------------------------------------------------- */
  function packPieces(pieces, L, W) {
    var best = null, bestScore = Infinity, nodes = 0;
    /* A cut is only needed where the piece is smaller than the stock it comes
       out of. A piece that already matches the available dimension needs no cut
       on that axis, so it costs no kerf. Anything smaller needs one saw pass,
       and the blade has to fit. */
    function roomFor(dim, avail) {
      if (dim > avail) return false;
      if (dim === avail) return true;
      return dim + CUT_KERF <= avail;
    }
    /* Raggedness: group placements by the edge they were cut from (their y) and
       count, per band, how many different heights share it. A clean band has
       one height and scores nothing. */
    function score(acc) {
      var bands = {}, rot = 0, ragged = 0, k;
      for (var i = 0; i < acc.length; i++) {
        if (acc[i].rot) rot++;
        k = String(acc[i].y);
        if (!bands[k]) bands[k] = [];
        if (bands[k].indexOf(acc[i].w) < 0) bands[k].push(acc[i].w);
      }
      for (k in bands) { if (bands.hasOwnProperty(k)) ragged += bands[k].length - 1; }
      return ragged * 100 + rot * 10;
    }
    function place(list, x, y, aL, aW, acc) {
      /* Three pieces, two orientations, two splits — under 500 nodes at worst.
         The cap is here so that a future fourth piece cannot hang a phone. */
      if (nodes++ > 20000) return;
      if (!list.length) {
        var s = score(acc);
        if (s < bestScore) { bestScore = s; best = acc.slice(); }
        return;
      }
      for (var i = 0; i < list.length; i++) {
        var p = list[i], rest = list.slice(0, i).concat(list.slice(i + 1));
        var ors = (p.l === p.w) ? [[p.l, p.w, false]] : [[p.l, p.w, false], [p.w, p.l, true]];
        for (var o = 0; o < ors.length; o++) {
          var pl = ors[o][0], pw = ors[o][1];
          if (!roomFor(pl, aL) || !roomFor(pw, aW)) continue;
          var acc2 = acc.concat([{ idx: p.idx, x: x, y: y, l: pl, w: pw, rot: ors[o][2] }]);
          place(rest, x + pl + CUT_KERF, y, aL - pl - CUT_KERF, aW, acc2);
          place(rest, x, y + pw + CUT_KERF, aL, aW - pw - CUT_KERF, acc2);
        }
      }
    }
    place(pieces, 0, 0, L, W, []);
    return best;
  }

  function pieceInputs() {
    var out = [];
    for (var i = 1; i <= state.pieces; i++) {
      var le = $('hp-cut-l-' + i), we = $('hp-cut-w-' + i);
      out.push({ i: i, l: parseInt(le ? le.value : '', 10), w: parseInt(we ? we.value : '', 10) });
    }
    return out;
  }

  function cutCheck() {
    if (state.fin !== 'sig') return { ok: true, msg: '', layout: null };
    var v = currentVariant();
    if (!v) return { ok: false, msg: cfg.copy.cutNeedsSlab, layout: null };
    var b = BANDS[v.id];
    if (!b || !b.l || !b.w) return { ok: true, msg: '', layout: null };
    var L = Math.max(b.l, b.w), W = Math.min(b.l, b.w);
    var specs = pieceInputs();
    if (specs.some(function (s) { return !s.l || !s.w; })) return { ok: false, msg: cfg.copy.cutPrompt, layout: null };
    var big = specs.filter(function (s) { return Math.max(s.l, s.w) > L || Math.min(s.l, s.w) > W; });
    if (big.length) {
      var which = state.pieces === 1 ? 'That' : ('Piece ' + big[0].i);
      return { ok: false, layout: null, msg: which + ' is bigger than the slab — a ' + v.options[cfg.idxSize] + ' cuts to a maximum of ' + L + ' × ' + W + 'mm.' };
    }
    /* THE SAW WILL NOT HOLD A SLIVER. Ravi, 23 Sep 2026: nothing narrower than
       MIN_CUT. The page used to accept any positive number, so a 20mm strip
       priced and added to the basket. */
    var thin = specs.filter(function (s) { return Math.min(s.l, s.w) < MIN_CUT; });
    if (thin.length) {
      var whichThin = state.pieces === 1 ? 'That piece is' : ('Piece ' + thin[0].i + ' is');
      return { ok: false, layout: null, msg: whichThin + ' under ' + MIN_CUT + 'mm on its short side. We do not cut narrower than ' + MIN_CUT + 'mm.' };
    }
    var pieces = specs.map(function (s, k) { return { idx: k, l: Math.max(s.l, s.w), w: Math.min(s.l, s.w) }; });
    var layout = packPieces(pieces, L, W);
    /* THE NO-FIT MESSAGE, SINGULAR AND PLURAL. This read "Those 1 pieces" for a
       single piece, and that branch is NOT unreachable — a note written earlier
       on 23 Sep claimed it was. 1500 x 895 on a 1500 x 900 slab clears the
       maximum-size gate above (895 is under 900) and then fails here on the saw
       allowance, which is exactly how a shopper finds it. Verified on staging.
       A second slab is only useful advice when there is more than one piece. */
    if (!layout) {
      var noFit = state.pieces === 1
        ? 'That piece will not come out of one ' + v.options[cfg.idxSize] + ' slab once the saw cut is allowed for — the blade takes about ' + CUT_KERF + 'mm, so a cut piece has to come in under the full slab size. Reduce a dimension.'
        : 'Those ' + state.pieces + ' pieces will not come out of one ' + v.options[cfg.idxSize] + ' slab once the saw cuts are allowed for — each cut loses about ' + CUT_KERF + 'mm, so the pieces cannot add up to the full slab. Reduce a dimension, or increase the quantity to buy a second slab.';
      return { ok: false, layout: null, msg: noFit };
    }
    var used = specs.reduce(function (a, s) { return a + s.l * s.w; }, 0);
    var waste = Math.round(100 - (used / (L * W)) * 100);
    var longest = Math.max(specs[0].l, specs[0].w);
    var spare = (longest === L) ? 0 : Math.max(0, L - longest - CUT_KERF);
    var msg = state.pieces === 1
      ? '✓ Cuts from a ' + v.options[cfg.idxSize] + ' slab' + (spare > 0 ? ' with ' + spare + 'mm to spare on the long edge once the saw cut is allowed for.' : '.')
      : '✓ All ' + state.pieces + ' pieces come out of one ' + v.options[cfg.idxSize] + ' slab, with ' + waste + '% offcut.';
    return { ok: true, msg: msg, layout: { placements: layout, L: L, W: W } };
  }

  function cutValue() {
    var s = pieceInputs();
    if (s.some(function (x) { return !x.l || !x.w; })) return '';
    if (s.length === 1) return s[0].l + ' × ' + s[0].w + 'mm';
    return s.map(function (x) { return 'Piece ' + x.i + ': ' + x.l + ' × ' + x.w + 'mm'; }).join(' · ');
  }

  function renderPieceRows() {
    var wrap = $('hp-piece-rows');
    if (!wrap || wrap.querySelectorAll('.hp__piecerow').length === state.pieces) return;
    var kept = {};
    for (var k = 1; k <= 3; k++) {
      var le = $('hp-cut-l-' + k), we = $('hp-cut-w-' + k);
      if (le || we) kept[k] = { l: le ? le.value : '', w: we ? we.value : '' };
    }
    var html = '';
    for (var i = 1; i <= state.pieces; i++) {
      var prev = kept[i] || { l: '', w: '' };
      html += '<div class="hp__piecerow">'
        + (state.pieces > 1 ? '<span class="hp__piecelabel">Piece ' + i + '</span>' : '')
        + '<input type="number" id="hp-cut-l-' + i + '" min="1" max="9999" inputmode="numeric" autocomplete="off" placeholder="' + cfg.copy.lengthPlaceholder + '" value="' + prev.l + '">'
        + '<span>×</span>'
        + '<input type="number" id="hp-cut-w-' + i + '" min="1" max="9999" inputmode="numeric" autocomplete="off" placeholder="' + cfg.copy.widthPlaceholder + '" value="' + prev.w + '">'
        + '<span>mm</span></div>';
    }
    wrap.innerHTML = html;
    wrap.querySelectorAll('input').forEach(function (el) { el.addEventListener('input', render); });
  }

  function renderDiagram(layout) {
    var el = $('hp-diagram');
    if (!el) return;
    if (!layout) { el.innerHTML = ''; return; }
    var L = layout.L, W = layout.W, VW = 420, sc = VW / L, VH = Math.round(W * sc);
    var s = '<svg viewBox="0 0 ' + VW + ' ' + VH + '" width="' + VW + '" height="' + VH + '" role="img" aria-label="Cutting layout">';
    s += '<rect x="0" y="0" width="' + VW + '" height="' + VH + '" fill="#f4f3f0"></rect>';
    layout.placements.forEach(function (p) {
      var x = p.x * sc, y = p.y * sc, w = p.l * sc, h = p.w * sc;
      s += '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" fill="#212121" stroke="#fff" stroke-width="2"></rect>';
      if (w > 46 && h > 22) s += '<text x="' + (x + w / 2) + '" y="' + (y + h / 2 + 5) + '" fill="#fff" font-size="14" text-anchor="middle">' + (p.idx + 1) + '</text>';
    });
    el.innerHTML = s + '</svg><p class="hp__diagramnote">' + cfg.copy.diagramNote + '</p>';
  }

  /* Each option dropdown carries its own price list, so opening it shows every
     price — which is the whole reason folding these costs nothing. */
  function renderOptionSelect(oi, vals) {
    var sel = optSelect(oi);
    if (!sel) return;
    var base = variantFor(vals);
    Array.prototype.slice.call(sel.options).forEach(function (opt) {
      var value = opt.getAttribute('data-value') || opt.value;
      var exists = combinationExists(oi, value);
      opt.disabled = !exists;
      var label = value;
      /* A sold-out option stays SELECTABLE, unlike one that does not exist.
         Merchant Center sends traffic to a specific ?variant= and that shopper
         must be able to see the exact thing the ad showed them; disabling the
         option would silently swap the slab and the price underneath them.
         The suffix carries the whole warning, the button refuses the sale.

         THE SUFFIX IS ADDED TO THE PRICE, NOT INSTEAD OF IT. Written first as
         another branch of this if/else chain, which displaced the price: the
         list read "1500 × 900 — sold out" with the £190 gone. That breaks the
         rule this whole control is built on, stated at the top of the section —
         "a dropdown does not hide the price list, it folds it; open one and
         every price is there" — and it blanked the exact figure the Google
         Shopping ad quotes. Being out of stock does not make the price a
         secret. Price first, then the status.

         The status itself is now asked as a CASCADE, via anyAvailableWith():
         each dropdown is constrained only by the slots BEFORE it and treats
         the later ones as wildcards, so a single missing combination marks
         one option rather than reporting the same outage three times. */
      if (!exists) {
        label += '  — ' + cfg.copy.selectUnavailable;
      } else {
        if (oi === cfg.idxSize) {
          var probe = vals.slice(); probe[oi] = value;
          var pv = variantFor(probe);
          label += '   ' + money(pv ? pv.price : cheapestWith(oi, value));
        } else {
          var probe2 = vals.slice(); probe2[oi] = value;
          var pv2 = variantFor(probe2);
          if (pv2 && base && pv2.price !== base.price) {
            label += '   ' + (pv2.price > base.price ? '+' : '−') + money(Math.abs(pv2.price - base.price));
          }
        }
        if (!anyAvailableWith(oi, value, vals)) label += '  — ' + soldOutSuffix();
      }
      if (opt.textContent !== label) opt.textContent = label;
    });
  }

  function repairOrphans(changed) {
    if (currentVariant()) return;
    for (var i = 0; i < cfg.optCount; i++) {
      if (i === changed) continue;
      var cur = valueAt(i);
      if (cur && combinationExists(i, cur)) continue;
      for (var k = 0; k < variants.length; k++) {
        var cand = String(variants[k].options[i]);
        if (combinationExists(i, cand)) { setValueAt(i, cand); break; }
      }
    }
  }

  function render() {
    if (finSel) state.fin = finSel.value;
    if (spdSel) state.speed = spdSel.value;
    if (delSel) state.del = delSel.value;
    if (pieceSel) state.pieces = Math.max(1, Math.min(3, parseInt(pieceSel.value, 10) || 1));

    var vals = chosen();
    for (var i = 0; i < cfg.optCount; i++) renderOptionSelect(i, vals);

    var v = currentVariant();
    var fr = freight(state.del);
    var q = qty(), svc = serviceCost(), del = (isDelivery(state.del) && fr !== null) ? fr : 0;
    var isOver = !!(v && BANDS[v.id] && BANDS[v.id].band === 'oversized');

    /* STOCK. Whatever is held at Milton Keynes is what we offer, so there is no
       above-stock branch here any more. The old one promised a Colchester
       transfer on the badge and added transfer_days to the dates; that promise
       is withdrawn (see qty(), which clamps q to MK stock before we get here).
       Every badge and every date below therefore describes dispatch from Milton
       Keynes and nothing else.

       Sold out is still asked first and still wins. See soldOutFor(). */
    var soldOut = soldOutFor(v);

    if (finSel) {
      var fo = finSel.options;
      if (fo[0]) fo[0].textContent = cfg.dispNone + ' — ' + cfg.copy.includedLabel;
      if (fo[1]) fo[1].textContent = cfg.dispSeal + '   +' + money(cfg.priceSeal);
      if (fo[2]) fo[2].textContent = cfg.dispSig + '   from +' + money(cfg.priceSigStd);
    }
    if (spdSel) {
      var so = spdSel.options;
      if (so[0]) so[0].textContent = cfg.copy.speedStandardLabel;
      if (so[1]) so[1].textContent = cfg.copy.speedPriorityLabel + '   +' + money(cfg.priceSigPri - cfg.priceSigStd);
    }
    if (delSel) {
      /* Each option prices ITSELF, not the current selection — otherwise both
         pallet rows would show whichever speed happened to be chosen. */
      var dopt = delSel.options;
      var frEco = freight('deliver'), frExp = freight('express');
      if (dopt[0]) dopt[0].textContent = cfg.copy.collectLabel + ' — ' + cfg.copy.freeLabel;
      if (dopt[1]) dopt[1].textContent = cfg.copy.deliverLabel + '   ' + (frEco === null ? 'from +' + money(cfg.rateStandard) : '+' + money(frEco));
      if (dopt[2]) dopt[2].textContent = cfg.copy.expressLabel + '   ' + (frExp === null ? 'from +' + money(cfg.rateStandardExpress) : '+' + money(frExp));
    }

    var nSize = $('hp-say-size'); if (nSize) nSize.textContent = cfg.copy.sizeNote;
    var nThk = $('hp-say-thk'); if (nThk) nThk.textContent = cfg.copy.thicknessNote;
    var nGrade = $('hp-say-grade');
    if (nGrade) nGrade.textContent = (vals[cfg.idxGrade] && /premium/i.test(vals[cfg.idxGrade])) ? cfg.copy.gradePremium : cfg.copy.gradeStandard;
    var nFin = $('hp-say-fin');
    if (nFin) {
      nFin.textContent = state.fin === 'none' ? (cfg.copy.noneDesc + ' ' + cfg.copy.upsellHint)
        : (state.fin === 'seal' ? cfg.copy.sealDesc : cfg.copy.sigDesc);
    }
    var nSpd = $('hp-say-speed');
    if (nSpd) nSpd.textContent = state.speed === 'priority' ? cfg.copy.speedPriorityNote : cfg.copy.speedStandardNote;
    var nDel = $('hp-say-del');
    if (nDel) {
      /* The oversize note keys off the BAND, not off a rate value. Comparing
         `fr === cfg.rateOversized` silently stopped firing on express, where
         the rate is £160 and never equals the economy oversized rate. */
      var delBase = state.del === 'collect' ? cfg.copy.collectDesc
        : (state.del === 'express' ? cfg.copy.expressDesc : cfg.copy.deliverDesc);
      nDel.textContent = delBase + (isDelivery(state.del) && isOver ? ' ' + cfg.copy.oversizeNote : '');
    }

    var sub = $('hp-sub-sig');
    if (sub) sub.className = 'hp__sub' + (state.fin === 'sig' ? ' is-on' : '');

    renderPieceRows();
    var cut = cutCheck();
    var cutEl = $('hp-cut-valid');
    if (cutEl) {
      cutEl.textContent = cut.msg;
      cutEl.className = 'hp__valid' + (cut.msg ? (cut.ok ? ' hp__valid--ok' : ' hp__valid--bad') : '');
    }
    renderDiagram(cut.layout);

    if (v) {
      var b = BANDS[v.id] || {};
      $('hp-vid').value = v.id;
      var hand = $('hp-hand');
      if (hand) hand.textContent = (b.kg ? 'We recommend a two-person lift. ' : '') + cfg.copy.handlingNote;

      /* The badge used to be a hardcoded string that read "In stock" for every
         variant forever, because nothing on the page knew any better. The tick is
         earned by the in-stock state only — a sold-out slab does not get a
         green tick next to the word "out". There is no longer a second, transfer
         wording: cfg.copy.stockTransfer is deliberately never read. */
      var stockEl = $('hp-stock');
      if (stockEl) {
        stockEl.textContent = soldOut
          ? soldOutBadge()
          : '✓ ' + cfg.copy.stockIn;
        /* Inline so hearth-parent.css stays out of this deploy entirely. */
        stockEl.style.color = soldOut ? '#9a1c1c' : '';
      }
    }

    /* KEY SPECS follows the selection.
       sections/hearth-key-specs.liquid renders the FULL size range, on purpose:
       a crawler and a shopper who has not chosen yet should see something true.
       Its own comment says hearth-main.liquid "then rewrites the span to the
       exact selection" — but this page runs hearth-parent.js, and the rebuild
       never carried that wiring across, so it sat on the range forever.
       Same contract as the old one: write the selection, fall back to
       data-default-label when there is nothing selected. */
    var ksEl = document.getElementById('hearth-spec-dimensions');
    if (ksEl) {
      if (!v) {
        var back = ksEl.getAttribute('data-default-label');
        if (back) ksEl.textContent = back;
      } else {
        /* Match the range's own formatting: sizes with the spaces removed,
           thickness after an em-dash. "1200 × 900" becomes "1200×900 — 20mm". */
        var ksTxt = String(v.options[cfg.idxSize] || '').replace(/\s+/g, '');
        if (cfg.idxThk !== null && cfg.idxThk !== undefined && v.options[cfg.idxThk]) {
          ksTxt += ' — ' + v.options[cfg.idxThk];
        }
        if (ksTxt) ksEl.textContent = ksTxt;
      }
    }

    /* ONE price, under the title, where Vivobarefoot puts theirs. The block
       above the button lists what makes it up but does NOT repeat the total. */
    var grand = v ? ((unitPrice(v, q) + svc) * q + del) : null;
    var priceEl = $('hp-price');
    if (priceEl) priceEl.textContent = grand === null ? cfg.copy.pricePending : money(grand);
    renderLadder(v, q);

    var linesEl = $('hp-lines');
    if (linesEl) {
      if (!v) { linesEl.innerHTML = ''; }
      else {
        var rows = [[v.title.split(' / ').join(' · ') + (q > 1 ? ' × ' + q : ''), money(unitPrice(v, q) * q)]];
        if (svc > 0) rows.push([serviceDisplay(), money(svc * q)]);
        var delLabel = state.del === 'express' ? cfg.copy.expressLineLabel
          : (state.del === 'deliver' ? cfg.copy.deliverLineLabel : cfg.copy.collectLineLabel);
        rows.push([delLabel, del === 0 ? cfg.copy.freeLabel : money(del)]);
        linesEl.innerHTML = rows.map(function (r) {
          return '<div class="hp__line"><span>' + r[0] + '</span><span>' + r[1] + '</span></div>';
        }).join('');
      }
    }

    var arriveEl = $('hp-arrive');
    if (arriveEl) {
      /* A sold-out slab has no collection day and no delivery window. Leaving
         the dates up is a promise we cannot keep — and it is the most specific,
         most believable thing on the page, so it is the one a shopper would
         hold us to. Hidden with the same switch that greys the button. */
      if (!v || soldOut) { arriveEl.style.display = 'none'; }
      else {
        var abs = state.fin === 'sig' ? (state.speed === 'priority' ? cfg.priorityDays : cfg.signatureDays) : null;
        var off = state.fin === 'seal' ? cfg.sealExtraDays : 0;
        var extra = off ? '<br>' + cfg.copy.sealDryNote : '';

        /* TRANSIT. A slab becomes collectable, and only then goes on a lorry.
           Both branches below used to state that a workshop order is DELIVERED
           on the day it becomes collectable, which cannot happen.
           Transit is derived from the stock path — collectable day 1, delivered
           days 3-5, so the lorry takes 2 to 4 working days. Derived rather than
           hardcoded so that changing the stock timings in the theme editor moves
           the workshop dates with them. Floored at 1: a same-day promise is the
           bug this block exists to fix. */
        var tMin = Math.max(1, cfg.stockMinDays - cfg.collectDays);
        var tMax = Math.max(tMin, cfg.stockMaxDays - cfg.collectDays);

        /* Express transit cannot be derived — no Shopify rate records it — so
           it comes from settings. Floored the same way. */
        var xMin = Math.max(1, cfg.expressMinDays);
        var xMax = Math.max(xMin, cfg.expressMaxDays);

        /* Every path is the same shape once you say it out loud: the slab
           becomes available on `readyDays`, then spends `transit` on a lorry.
           For a stock slab readyDays + tMin lands exactly on stockMinDays, so
           this replaces the old separate stock and workshop branches rather
           than adding a third. */
        /* Dispatch is from Milton Keynes stock only. cfg.transferDays used to be
           added in here whenever the order ran past MK stock; the quantity is
           clamped to MK stock now, so there is nothing left to add and these
           dates are simply the dispatch dates. The transfer_days theme setting is
           left in place on purpose — clearing it makes the schema default render,
           and this store has older, wrong copy sitting in its defaults. */
        var readyDays = (abs === null ? cfg.collectDays + off : abs);
        var useExpress = state.del === 'express';
        var dMin = readyDays + (useExpress ? xMin : tMin);
        var dMax = readyDays + (useExpress ? xMax : tMax);
        var readyStr = longDate(addWorkingDays(readyDays));
        var window_ = dMin === dMax
          ? shortDate(addWorkingDays(dMin))
          : shortDate(addWorkingDays(dMin)) + ' – ' + shortDate(addWorkingDays(dMax));

        var html;
        if (state.del === 'collect') {
          /* The hint prices up the cheaper option, so quote economy here. */
          html = '<b>Ready to collect ' + readyStr + '.</b>'
            + '<br>Choose delivery and it arrives ' + shortDate(addWorkingDays(readyDays + tMin)) + ' – ' + shortDate(addWorkingDays(readyDays + tMax)) + '.';
        } else {
          html = '<b>Delivered ' + window_ + '.</b>'
            + '<br>Or collect free from Milton Keynes on ' + readyStr + '.'
            + (abs === null ? '' : ' ' + cfg.copy.workshopTimeNote);
        }
        arriveEl.innerHTML = html + extra;
        arriveEl.style.display = 'block';
      }
    }

    /* Sold out outranks the cutting-size prompt. Asking a shopper to measure a
       slab they cannot buy wastes their time and reads as a broken form. */
    var soLine = soldOutLine();
    if (soLine) {
      soLine.textContent = soldOut ? soldOutNote() : '';
      soLine.hidden = !soldOut;
    }

    /* Above Milton Keynes stock the page stops promising and hands over a phone
       number instead. Suppressed while the slab is sold out: the sold-out note
       is the truer sentence, and two red lines in one box read as a broken
       form rather than as two facts. */
    var capLine = qtyCapLine();
    if (capLine) {
      var capped = qtyCapped && !soldOut;
      capLine.textContent = capped ? qtyCapNote() : '';
      capLine.hidden = !capped;
    }

    /* BSD-110: below a trade minimum (stock under the minimum) the basket would refuse it. */
    var belowMin = !!v && q < minQty(v);
    var ready = !!v && cut.ok && !soldOut && !belowMin;
    var label = !v ? cfg.copy.atcIncomplete
      : (soldOut ? soldOutBtnLabel()
      : belowMin ? 'Call 01908 46 46 56 to order'
      : (!cut.ok ? cfg.copy.atcNeedsCut : cfg.copy.atcLabel));
    ['hp-atc', 'hp-sticky-btn'].forEach(function (id) {
      var btn = $(id);
      if (!btn) return;
      btn.disabled = !ready;
      btn.textContent = label;
    });

    $('hp-qty-hidden').value = q;
    var sp = $('hp-sticky-price'); if (sp) sp.textContent = priceEl ? priceEl.textContent : '';
    var sm = $('hp-sticky-meta');
    if (sm) sm.textContent = v ? v.title.split(' / ').join(' · ') + (svc > 0 ? ' · ' + serviceDisplay() : '') : '';

    syncUrl(v);
  }

  /* Merchant Center requires a distinct landing URL per variant with a
     matching price. replaceState so the back button still leaves the page. */
  function syncUrl(v) {
    if (!v || !window.history || !history.replaceState) return;
    try {
      var u = new URL(window.location.href);
      if (u.searchParams.get('variant') === String(v.id)) return;
      u.searchParams.set('variant', v.id);
      history.replaceState({}, '', u.toString());
    } catch (e) { /* older browsers keep the bare URL */ }
  }

  function applyVariant(v) { for (var i = 0; i < cfg.optCount; i++) setValueAt(i, String(v.options[i])); }

  /* A ?variant= in the URL always wins — that is ad traffic and it must show
     exactly what was advertised. Then the configured best seller. */
  function setInitial() {
    var id = null;
    try { id = new URL(window.location.href).searchParams.get('variant'); } catch (e) { id = null; }
    if (id) {
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(id)) { applyVariant(variants[i]); return; }
    }
    if (cfg.defaults && cfg.defaults.length === cfg.optCount) {
      var m = variantFor(cfg.defaults);
      if (m) { applyVariant(m); return; }
    }
    for (var k = 0; k < variants.length; k++) if (variants[k].available) { applyVariant(variants[k]); return; }
    if (variants.length) applyVariant(variants[0]);
  }

  document.querySelectorAll('.hp__optselect').forEach(function (sel) {
    sel.addEventListener('change', function () { repairOrphans(parseInt(sel.getAttribute('data-oi'), 10)); render(); });
  });
  [finSel, spdSel, delSel, pieceSel].forEach(function (s) { if (s) s.addEventListener('change', render); });
  var qtyEl = $('hp-qty'); if (qtyEl) qtyEl.addEventListener('input', render);

  document.querySelectorAll('.hp__thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      var img = $('hp-img');
      if (img) img.src = t.getAttribute('data-src');
      document.querySelectorAll('.hp__thumb').forEach(function (x) { x.classList.remove('hp__thumb--on'); });
      t.classList.add('hp__thumb--on');
    });
  });

  var ct = $('hp-cont-toggle'), cfds = $('hp-cont-fields'), copen = false;
  if (ct) ct.addEventListener('click', function () {
    copen = !copen;
    cfds.className = 'hp__contfields' + (copen ? ' is-on' : '');
    ct.textContent = copen ? cfg.copy.contractorOpen : cfg.copy.contractorClosed;
  });

  var atcBtn = $('hp-atc'), sticky = $('hp-sticky');
  if (atcBtn && sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { sticky.className = 'hp__sticky' + (e.isIntersecting ? '' : ' is-on'); });
    }, { threshold: 0 }).observe(atcBtn);
  }
  var sb = $('hp-sticky-btn'); if (sb) sb.addEventListener('click', function () { atcBtn.click(); });

  $('hp-form').addEventListener('submit', function (e) {
    e.preventDefault();
    var v = currentVariant(), cut = cutCheck();
    if (!v || !cut.ok) return;
    /* The disabled button is not the only way into a submit — Enter inside the
       cutting-size fields posts the form too. Re-render so the shopper sees why
       nothing happened rather than being left with a dead press. */
    if (soldOutFor(v)) { render(); return; }
    var btns = [$('hp-atc'), $('hp-sticky-btn')];
    btns.forEach(function (b) { if (b) { b.disabled = true; b.textContent = cfg.copy.atcAdding; } });

    var q = qty(), key = serviceKey(), svcId = key ? cfg.svc[key] : null;
    var props = {};

    /* THE CART PAIR TOKEN.
       assets/bsd-cart-pairing.js matches a service line to its slab on this,
       NOT on product title. One parent means all twelve sizes share a title,
       so title matching pairs a service to every slab in the basket — remove
       one slab and every service goes with it. Unique per add, stamped on
       both lines. Underscore keeps it hidden from the customer while still
       reaching the order, so the workshop can see it.

       Side effect, and the correct one: two adds of the same slab-with-service
       no longer merge into one line of qty 2, because their tokens differ.
       They stay as two independent pairs. Slab-only adds carry no token and
       merge exactly as Shopify would normally. */
    var pairToken = null;
    if (svcId) {
      pairToken = Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
      props['_pair'] = pairToken;
      props['Service'] = serviceDisplay();
      var cv = cutValue();
      if (cv) props['Dimensions'] = cv;
      if (state.fin === 'sig' && state.pieces > 1) props['Pieces'] = String(state.pieces);
    }
    var cn = $('hp-cont-name').value, cp = $('hp-cont-phone').value, ce = $('hp-cont-email').value;
    if (cn) props['Installer name'] = cn;
    if (cp) props['Installer phone'] = cp;
    if (ce) props['Installer email'] = ce;

    /* THE DELIVERY CHOICE, CARRIED TO THE CART. Added 13 Sep 2026, Session L.

       Step 5 was decorative. The shopper picked "Collect from Milton Keynes —
       free", the buy box totalled it as free, and nothing about that choice
       left this page: /cart/add.js got the slab and the installer fields and
       nothing else. The cart then showed £95 with no delivery line at all, and
       checkout opened on the SHIP tab with Economy Pallet £78 pre-selected —
       £173 on a £95 slab, first seen at the last step.

       That is the post-cart leak. Delivery went from free to £78 on 16 Aug 2026
       (first paid order #BLU-7107) and cart-to-checkout fell from ~70% to ~35%
       in the same week, on flat cart-adds.

       This does NOT change what Shopify charges. Rates live in delivery
       profiles, not in cart properties, and nothing here can move them. What it
       does is make the choice VISIBLE in the cart and on the order — so the
       shopper is reminded what they picked while they can still change their
       mind, the office can see it on the packing slip, and a collecting shopper
       is told where the free option actually lives: behind checkout's PICKUP
       tab, which is a separate control from the shipping rates and is the one
       thing nobody discovers on their own.

       Read through say() so the wording becomes theme-editable the moment the
       key is added to sections/hearth-parent.liquid — the same contract the
       sold-out copy above uses. Until then the fallback ships. */
    var delProp = state.del === 'express' ? cfg.copy.expressLineLabel
      : (state.del === 'deliver' ? cfg.copy.deliverLineLabel : cfg.copy.collectLineLabel);
    var delFreight = freight(state.del);
    delProp += ' — ' + ((isDelivery(state.del) && delFreight !== null) ? money(delFreight) : cfg.copy.freeLabel);
    if (!isDelivery(state.del)) delProp += '. ' + say('pickupHint', 'Simply choose Pickup at the next step');
    props['_delivery'] = delProp; /* BSD-043: hidden; real delivery = checkout shipping line */

    var items = [{ id: v.id, quantity: q, properties: props }];
    if (svcId) {
      /* 'For product' is kept for the legacy fallback in bsd-cart-pairing.js
         and for anything else still reading it. '_pair' is what actually
         pairs now. 'Slab' rides along so the packing slip says which slab. */
      items.push({
        id: svcId,
        quantity: q,
        properties: {
          'For product': cfg.productTitle,
          'Slab': v.title,
          '_pair': pairToken,
          '_image': cfg.productImage
        }
      });
    }
    function addOne(item) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Add to cart failed'); });
        return r.json();
      });
    }
    addOne(items[0])
      .then(function () { if (items.length > 1) return addOne(items[1]); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function (err) {
        btns.forEach(function (b) { if (b) b.disabled = false; });
        render();
        alert(cfg.copy.atcError);
        if (window.console) console.error('Hearth parent ATC error:', err);
      });
  });

  setInitial();
  render();
  loadBreaks();
})();
